import { Proscalping } from './Proscalping'
import { Cryptosquad } from './Cryptosquad'

export const Partner = {
  Proscalping,
  Cryptosquad,
}
